import React, { useState, useRef, useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { LangContext } from '../../context/lang-context'
import onClickAway from '../../util/onClickAway'
import imgSm from '../../assets/images/logo-retail24-sm.png'
// import NotificationTicker from "../NotificationTicker/NotificationTicker";
import { EndSessionTimerContext } from '../../context/end-session-timer-context'
import useAuth from '../../hooks/auth-hook';
import axios from 'axios'
import { API_URL } from '../../config/config'
import useMssqlApi from '../../hooks/fetchMSSQL-hook'

// eslint-disable-next-line react/display-name
export default ({
                  toggleSidebar,
                  navlinks,
                  headerData: { text, subtext } = {},
                  customerName,
                  headerClassName = 'd-flex flex-column justify-content-center p-0',
                }) => {
  const navbarRef = useRef(null)
  const { TRL_Pack } = useContext(LangContext)
  const { Timer } = useContext(EndSessionTimerContext)
  const [mobileNavbar, setMobileNavbar] = useState(false)
  const [dotColor, setDotColor] = useState(navigator.onLine ? '#097116' : '#ff0000')

  const [showSwitchDbModal, setShowSwitchDbModal] = useState(false)
  const [switchClientId, setSwitchClientId] = useState(sessionStorage.getItem('clientId') || '')
  const [mysqlProcesses, setMysqlProcesses] = useState([])
  const [mssqlProcesses, setMssqlProcesses] = useState([])
  const [loadingProcesses, setLoadingProcesses] = useState(false)
  const [selectedProcess, setSelectedProcess] = useState(null)
  const [autoRefreshProcesses, setAutoRefreshProcesses] = useState(false)

  const { fetchMssqlApi } = useMssqlApi()

  const openMobileNavbar = () => {
    setMobileNavbar(true)
    onClickAway(navbarRef, closeMobileNavbar)
  }

  const closeMobileNavbar = () => setMobileNavbar(false)

  const { login } = useAuth();

  const switchDb = async (clientIdFromModal = switchClientId) => {
    let rawDevUser = sessionStorage.getItem('DevUser');

    if (!rawDevUser) {
      const devEmail = window.prompt('Brak DevUser. Podaj email:') || '';
      if (!devEmail) return;

      const devPassword = window.prompt('Podaj hasło:') || '';
      if (!devPassword) return;

      sessionStorage.setItem(
        'DevUser',
        JSON.stringify({
          email: devEmail,
          password: devPassword
        })
      );

      rawDevUser = sessionStorage.getItem('DevUser');
    }

    let { email, password } = JSON.parse(rawDevUser);

    const clientId = (clientIdFromModal || '').trim().toLowerCase();

    if (!clientId) return alert('Podaj clientId');

    if (clientId === 'console') {
      const rawConsoleUser = sessionStorage.getItem('ConsoleUser');

      if (rawConsoleUser) {
        const consoleUser = JSON.parse(rawConsoleUser);
        email = consoleUser.email;
        password = consoleUser.password;
      } else {
        email = window.prompt('Podaj email do console:') || '';
        if (!email) return;

        password = window.prompt('Podaj hasło do console:') || '';
        if (!password) return;

        sessionStorage.setItem(
          'ConsoleUser',
          JSON.stringify({
            email,
            password
          })
        );
      }
    }

    try {
      const res = await axios.put(`${API_URL}/api/auth/login`, {
        Email: email,
        Password: password,
        ClientId: clientId,
        token: ''
      });

      if (!res?.data?.token) throw new Error('Backend nie zwrócił tokena');

      if (clientId === 'console') {
        sessionStorage.removeItem('permissions');
        login(res.data.token, clientId);
        window.location.reload();
        return;
      }

      const permissionsRes = await axios.get(`${API_URL}/api/user-permissions`);
      const permissions = permissionsRes?.data || [];

      sessionStorage.setItem('permissions', JSON.stringify(permissions));
      login(res.data.token, clientId);

      window.location.reload();
    } catch (e) {
      if (clientId === 'console') {
        sessionStorage.removeItem('ConsoleUser');

        const retry = window.confirm(
          'Nie udało się zalogować do console. Czy chcesz ponownie wpisać login i hasło?'
        );

        if (retry) {
          const newEmail = window.prompt('Podaj email do console:') || '';
          if (!newEmail) return;

          const newPassword = window.prompt('Podaj hasło do console:') || '';
          if (!newPassword) return;

          sessionStorage.setItem(
            'ConsoleUser',
            JSON.stringify({
              email: newEmail,
              password: newPassword
            })
          );

          return switchDb('console');
        }
      } else {
        sessionStorage.removeItem('DevUser');

        const retry = window.confirm(
          'Nie udało się przełączyć bazy. Czy chcesz ponownie wpisać login i hasło DevUser?'
        );

        if (retry) {
          const newEmail = window.prompt('Podaj email:') || '';
          if (!newEmail) return;

          const newPassword = window.prompt('Podaj hasło:') || '';
          if (!newPassword) return;

          sessionStorage.setItem(
            'DevUser',
            JSON.stringify({
              email: newEmail,
              password: newPassword
            })
          );

          return switchDb(clientId);
        }
      }

      alert('Nie udało się przełączyć bazy');
    }
  };

  const loadProcesses = () => {
    if (loadingProcesses) return;

    setLoadingProcesses(true);

    fetchMssqlApi(
      'processList',
      {
        method: 'GET',
        showLoader: false,
        isErrorAcceptable: true
      },
      (data) => {
        setMssqlProcesses(data?.mssql || []);
        setMysqlProcesses(data?.mysql || []);
        setLoadingProcesses(false);
      },
      () => {
        setLoadingProcesses(false);
      }
    );
  };

  useEffect(() => {
    if (!autoRefreshProcesses || !showSwitchDbModal) return;

    const interval = setInterval(() => {
      loadProcesses();
    }, 2000);

    return () => clearInterval(interval);
  }, [autoRefreshProcesses, showSwitchDbModal, loadingProcesses]);

  const closeSwitchDbModal = () => {
    setShowSwitchDbModal(false)
    setSelectedProcess(null)
    setAutoRefreshProcesses(false)
  }

  const formatDuration = (seconds) => {
    const totalSeconds = Number(seconds || 0)

    const h = Math.floor(totalSeconds / 3600)
    const m = Math.floor((totalSeconds % 3600) / 60)
    const s = Math.floor(totalSeconds % 60)

    if (h > 0) return `${h}h ${m}m ${s}s`
    if (m > 0) return `${m}m ${s}s`
    return `${s}s`
  }

  const getProcessId = (p) =>
    p?.process_id || p?.Id || p?.id || p?.session_id || p?.spid || ''

  const getDuration = (p) =>
    p?.duration_seconds || p?.Time || p?.time || p?.total_elapsed_time_seconds || 0

  const getCpu = (p) =>
    p?.cpu_seconds || (p?.cpu_time ? p.cpu_time / 1000 : 0)

  const getState = (p) =>
    p?.State || p?.state || p?.status || p?.wait_info || p?.command || p?.Command || ''

  const getLogin = (p) =>
    p?.User || p?.user || p?.login_name || p?.login || ''

  const getDb = (p) =>
    p?.Db || p?.db || p?.database_name || ''

  const getSqlText = (p) =>
    p?.sql_text || p?.SQL_TEXT || p?.text || ''

  const formatSql = (sql = '') => {
    return sql
      .replace(/\s+/g, ' ')
      .replace(/\bSELECT\b/gi, '\nSELECT')
      .replace(/\bFROM\b/gi, '\nFROM')
      .replace(/\bWHERE\b/gi, '\nWHERE')
      .replace(/\bINNER JOIN\b/gi, '\nINNER JOIN')
      .replace(/\bLEFT JOIN\b/gi, '\nLEFT JOIN')
      .replace(/\bRIGHT JOIN\b/gi, '\nRIGHT JOIN')
      .replace(/\bFULL JOIN\b/gi, '\nFULL JOIN')
      .replace(/\bJOIN\b/gi, '\nJOIN')
      .replace(/\bAND\b/gi, '\n  AND')
      .replace(/\bOR\b/gi, '\n  OR')
      .replace(/\bORDER BY\b/gi, '\nORDER BY')
      .replace(/\bGROUP BY\b/gi, '\nGROUP BY')
      .replace(/\bHAVING\b/gi, '\nHAVING')
      .replace(/\bINSERT INTO\b/gi, '\nINSERT INTO')
      .replace(/\bUPDATE\b/gi, '\nUPDATE')
      .replace(/\bDELETE FROM\b/gi, '\nDELETE FROM')
      .trim()
  }

  let list = []

  let machineList = []
  const [collapseMachine, setCollapseMachine] = useState(false)

  let warehouseList = []
  const [collapseWarehouse, setCollapseWarehouse] = useState(false)

  let raportList = []
  const [collapseRaport, setCollapseRaport] = useState(false)

  let configurationList = []
  const [collapseConfiguration, setCollapseConfiguration] = useState(false)

  const handleClick = (type) => {
    switch (type) {
      case 'machine':
        setCollapseMachine(!collapseMachine)
        break
      case 'warehouse':
        setCollapseWarehouse(!collapseWarehouse)
        break
      case 'raport':
        setCollapseRaport(!collapseRaport)
        break
      case 'configuration':
        setCollapseConfiguration(!collapseConfiguration)
        break
      default:
        break
    }
  }

  const ListItem = ({ text, path }) => (
    <li className="nav-item">
      <Link
        to={path}
        onClick={closeMobileNavbar}
        className="nav-link py-2 text-muted btn btn-link font-weight-normal"
      >
        {text}
      </Link>
    </li>
  )

  const GroupItem = ({ text, type }) => (
    <li className="nav-item">
      <Link
        onClick={() => handleClick(type)}
        className="nav-link py-2 text-muted btn btn-link font-weight-normal"
      >
        {text}
      </Link>
    </li>
  )

  return (
    <header
      ref={navbarRef}
      className={`${headerClassName} header-shadow-adjustment`}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.05)'
      }}
    >
      <div className="d-flex align-items-center justify-content-between w-100">
        <div className="d-flex">
          <button
            className="mr-2 d-none d-lg-flex btn p-2"
            style={{ fontSize: '1.25rem' }}
            onClick={toggleSidebar}
          >
            <i className="fas fa-bars text-muted" />
          </button>

          <Link to={'/machines'} className="d-block d-lg-none ">
            <img src={imgSm} height={50} />
          </Link>

          <p className="mb-0 font-weight-bolder d-none d-lg-block text-center page-header-adjustment pe-none">
            {text}
          </p>

          <div className="d-flex d-lg-none align-items-center ml-2">
            <p className="mb-0 font-weight-bolder text-center header-adjustment">
              {text}
            </p>
          </div>

          {subtext && (
            <span className="ml-2 font-weight-bolder align-self-end">{subtext}</span>
          )}
        </div>

        <div>
          <div className="d-flex align-items-center">
            {/*process.env.REACT_APP_LOCAL_DB === "false" && (
              <div className="notif-slot">
                <NotificationTicker />
              </div>
            )*/}

            <Timer />

            {window.location.hostname === 'localhost' && process.env.REACT_APP_LOCAL_DB === "false" && (
              <button
                type="button"
                className="btn btn-sm btn-outline-secondary ml-2"
                onClick={() => setShowSwitchDbModal(true)}
                title="Przełącz bazę"
              >
                <i className="fa-solid fa-database"></i>
              </button>
            )}

            <span className="ml-2 font-weight-bolder d-none d-lg-flex mr-3 pe-none customer-header-adjustment">
              {customerName}
            </span>
          </div>

          <div className={'d-lg-none d-flex'}>
            <button
              className="ml-auto d-flex d-lg-none btn align-self-center"
              onClick={mobileNavbar ? closeMobileNavbar : openMobileNavbar}
            >
              <i className="fas fa-bars text-muted" />
            </button>

            <div className={'position-relative d-lg-none d-flex left-0 '}>
              <i className={`fas fa-circle fa-sm`} style={{ color: dotColor }}></i>
            </div>
          </div>
        </div>
      </div>

      {mobileNavbar && (
        <nav className="d-lg-none collapse navbar-collapse px-3 pb-2 show">
          <ul className="navbar-nav ml-auto">
            {process.env.REACT_APP_LOCAL_DB === "false" && !sessionStorage.getItem('isMobile') && (
              <ListItem text={TRL_Pack.navbar.start} path={'/start'} icon={'fas fa-play-circle'} />
            )}

            {navlinks.map((navlink, idx) => (
              navlink.group === 'machine' && (machineList.push(<ListItem key={idx} {...navlink} />)),
              navlink.group === 'warehouse' && (warehouseList.push(<ListItem key={idx} {...navlink} />)),
              navlink.group === 'raport' && (raportList.push(<ListItem key={idx} {...navlink} />)),
              navlink.group === 'configuration' && (configurationList.push(<ListItem key={idx} {...navlink} />)),
              navlink.group == undefined && (list.push(<ListItem key={idx} {...navlink} />)),
                null
            ))}

            {machineList.length > 0 && (
              <GroupItem text={TRL_Pack.navbar.machines} type={'machine'} />
            )}
            {collapseMachine ? machineList : null}

            {warehouseList.length > 0 && (
              <GroupItem text={TRL_Pack.navbar.warehouse} type={'warehouse'} />
            )}
            {collapseWarehouse ? warehouseList : null}

            {raportList.length > 0 && (
              <GroupItem text={TRL_Pack.navbar.raports} type={'raport'} />
            )}
            {collapseRaport ? raportList : null}

            {configurationList.length > 0 && (
              <GroupItem text={TRL_Pack.navbar.config} type={'configuration'} />
            )}
            {collapseConfiguration ? configurationList : null}

            {list}
          </ul>
        </nav>
      )}

      {showSwitchDbModal && (
        <div
          className="modal d-block"
          tabIndex="-1"
          style={{ backgroundColor: 'rgba(0,0,0,0.55)' }}
        >
          <div className="modal-dialog modal-xl modal-dialog-scrollable" style={{ maxWidth: '95vw' }}>
            <div className="modal-content">
              <div className="modal-header py-2">
                <div>
                  <h5 className="modal-title mb-0">Przełącz bazę / aktywne procesy</h5>
                  <small className="text-muted">
                    Podgląd MySQL i MSSQL — kliknij proces, aby zobaczyć SQL
                  </small>
                </div>

                <button
                  type="button"
                  className="close"
                  onClick={closeSwitchDbModal}
                >
                  <span>&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <div className="d-flex align-items-end mb-3">
                  <div className="form-group mb-0 mr-2" style={{ minWidth: 260 }}>
                    <label className="mb-1">ClientId</label>
                    <input
                      className="form-control form-control-sm"
                      value={switchClientId}
                      onChange={(e) => setSwitchClientId(e.target.value)}
                      placeholder="np. bem"
                    />
                  </div>

                  <button
                    type="button"
                    className="btn btn-sm btn-primary mr-2"
                    onClick={() => switchDb()}
                  >
                    <i className="fa-solid fa-database mr-1" />
                    Przełącz bazę
                  </button>

                  <button
                    type="button"
                    className="btn btn-sm btn-outline-secondary mr-2"
                    onClick={loadProcesses}
                    disabled={loadingProcesses}
                  >
                    <i className="fa-solid fa-rotate mr-1" />
                    {loadingProcesses ? 'Ładowanie...' : 'Odśwież procesy'}
                  </button>

                  <button
                    type="button"
                    className={`btn btn-sm ${
                      autoRefreshProcesses ? 'btn-danger' : 'btn-outline-success'
                    }`}
                    onClick={() => setAutoRefreshProcesses(!autoRefreshProcesses)}
                  >
                    <i className="fa-solid fa-clock-rotate-left mr-1" />
                    {autoRefreshProcesses ? 'Stop auto' : 'Auto 2s'}
                  </button>
                </div>

                <div className="row">
                  <div className="col-lg-6 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <h6 className="mb-0">MySQL</h6>
                      <span className="badge badge-light">{mysqlProcesses.length}</span>
                    </div>

                    <div style={{ maxHeight: 360, overflow: 'auto', border: '1px solid #dee2e6' }}>
                      <table className="table table-sm table-hover mb-0">
                        <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                          <tr>
                            <th>PID</th>
                            <th>Czas</th>
                            <th>CPU</th>
                            <th>Stan</th>
                            <th>Login</th>
                            <th>Baza</th>
                          </tr>
                        </thead>

                        <tbody>
                          {mysqlProcesses.length === 0 && (
                            <tr>
                              <td colSpan="6" className="text-muted text-center py-3">
                                Brak danych
                              </td>
                            </tr>
                          )}

                          {mysqlProcesses.map((p, idx) => (
                            <tr
                              key={idx}
                              style={{ cursor: 'pointer' }}
                              onClick={() => setSelectedProcess({ type: 'MySQL', ...p })}
                            >
                              <td>{getProcessId(p)}</td>
                              <td>{formatDuration(getDuration(p))}</td>
                              <td>{formatDuration(getCpu(p))}</td>
                              <td
                                style={{
                                  maxWidth: 140,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                                title={getState(p)}
                              >
                                {getState(p)}
                              </td>
                              <td>{getLogin(p)}</td>
                              <td>{getDb(p)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-lg-6 mb-3">
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <h6 className="mb-0">MSSQL</h6>
                      <span className="badge badge-light">{mssqlProcesses.length}</span>
                    </div>

                    <div style={{ maxHeight: 360, overflow: 'auto', border: '1px solid #dee2e6' }}>
                      <table className="table table-sm table-hover mb-0">
                        <thead className="thead-light" style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                          <tr>
                            <th>PID</th>
                            <th>Czas</th>
                            <th>CPU</th>
                            <th>Stan</th>
                            <th>Login</th>
                            <th>Baza</th>
                          </tr>
                        </thead>

                        <tbody>
                          {mssqlProcesses.length === 0 && (
                            <tr>
                              <td colSpan="6" className="text-muted text-center py-3">
                                Brak danych
                              </td>
                            </tr>
                          )}

                          {mssqlProcesses.map((p, idx) => (
                            <tr
                              key={idx}
                              style={{ cursor: 'pointer' }}
                              onClick={() => setSelectedProcess({ type: 'MSSQL', ...p })}
                            >
                              <td>{getProcessId(p)}</td>
                              <td>{formatDuration(getDuration(p))}</td>
                              <td>{formatDuration(getCpu(p))}</td>
                              <td
                                style={{
                                  maxWidth: 140,
                                  whiteSpace: 'nowrap',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis'
                                }}
                                title={getState(p)}
                              >
                                {getState(p)}
                              </td>
                              <td>{getLogin(p)}</td>
                              <td>{getDb(p)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {selectedProcess && (
                  <div className="card mt-2">
                    <div className="card-header py-2 d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{selectedProcess.type}</strong>

                        <span className="ml-2 text-muted">
                          PID: {getProcessId(selectedProcess)}
                        </span>

                        <span className="ml-2 text-muted">
                          DB: {getDb(selectedProcess)}
                        </span>

                        <span className="ml-2 text-muted">
                          CPU: {formatDuration(getCpu(selectedProcess))}
                        </span>

                        <span className="ml-2 text-muted">
                          Czas: {formatDuration(getDuration(selectedProcess))}
                        </span>

                        <span className="ml-2 text-muted">
                          Login: {getLogin(selectedProcess)}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => setSelectedProcess(null)}
                      >
                        Ukryj SQL
                      </button>
                    </div>

                    <div className="card-body p-0">
                      <pre
                        className="mb-0 p-3"
                        style={{
                          maxHeight: 360,
                          overflow: 'auto',
                          backgroundColor: '#1e1e1e',
                          color: '#d4d4d4',
                          fontSize: 12,
                          lineHeight: 1.45,
                          whiteSpace: 'pre-wrap'
                        }}
                      >
                        {formatSql(getSqlText(selectedProcess)) || 'Brak SQL text'}
                      </pre>
                    </div>
                  </div>
                )}
              </div>

              <div className="modal-footer py-2">
                <button
                  type="button"
                  className="btn btn-sm btn-secondary"
                  onClick={closeSwitchDbModal}
                >
                  Zamknij
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}